// extracted by mini-css-extract-plugin
export default {"bordered":"ClusterPriceCell_bordered__TjdpO","unavailable":"ClusterPriceCell_unavailable__WmRxW"};